import { Section, SectionDto } from './sections.types';

type ParseSectionsListForUI = (input: SectionDto[]) => Section[];
type ParseSectionForUI = (input: SectionDto) => Section;

const parseSectionsListForUI: ParseSectionsListForUI = raw => raw;

const parseSectionForUI: ParseSectionForUI = raw => raw;

export { parseSectionsListForUI, parseSectionForUI };
